const DetailDateFormatter = (timestamp) => {
  const date = new Date(timestamp);

  // Define an array of month names
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Format the date as 'Mon DD, YYYY'
  const formattedDate = `${monthNames[date.getMonth()]} ${String(date.getDate()).padStart(
    2,
    '0'
  )}, ${date.getFullYear()}`;

  return formattedDate;
};
export default DetailDateFormatter;
